import { IOpeningTime } from '../../types';

export const doOpeningTimesOverlap = (times: IOpeningTime[]): boolean => {
  const openingTimes = [...times]
    .filter((time) => time.start !== '' || time.end !== '')
    .sort((a, b) => (a.start > b.start ? 1 : -1));
  for (let i = 0; i < openingTimes.length; i++) {
    if (openingTimes.length > i + 1) {
      if (openingTimes[i].end >= openingTimes[i + 1].start) {
        return true;
      }
    }
  }

  return false;
};
